import * as TypeGraphQL from "type-graphql";
export var UserRole;
(function (UserRole) {
    UserRole["OWNER"] = "OWNER";
    UserRole["ADMIN"] = "ADMIN";
    UserRole["SUPERADMIN"] = "SUPERADMIN";
    UserRole["USER"] = "USER";
})(UserRole || (UserRole = {}));
TypeGraphQL.registerEnumType(UserRole, {
    name: "UserRole",
    description: undefined,
});
//# sourceMappingURL=UserRole.js.map